<script lang="ts">
import { widgetOptions } from '@/modules/options'

import WidgetBrandingCustom from './WidgetBrandingCustom.svelte'
import WidgetBrandingDefault from './WidgetBrandingDefault.svelte'

const { features, customBrandingEnabled } = widgetOptions.getOptions()
const isWhiteLabelEnabled = !!(features && features.whiteLabel)

let shouldRenderBranding: boolean = $derived(!isWhiteLabelEnabled)
</script>

{#if shouldRenderBranding}
	<div class="flex-center text-xs text-gray-300 select-none">
		{#if customBrandingEnabled}
			<WidgetBrandingCustom />
		{:else}
			<WidgetBrandingDefault />
		{/if}
	</div>
{/if}
